import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { DefaultSmartViewId, IntegrityMonitorSmartViewData } from '../types';
import { IntegrityMonitorIdentifier } from '../../../common/utils/types';

export class IntegrityMonitorRulesSmartViewsDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<IntegrityMonitorSmartViewData> {
    return {
      ruleSetIdentifiers: await this.getRuleSetIdentifiersData(),
      activeViewId: DefaultSmartViewId.ALL_RULES,
    };
  }

  async getRuleSetIdentifiersData(): Promise<Array<IntegrityMonitorIdentifier>> {
    const request = {
      companyId: this.dependencies.getActiveCompany().companyId,
    };

    const response = await this.dependencies.api.clients.IntegrityMonitorRuleSets.getRuleSetIdentifiers(
      request
    ).toPromise();

    if (!response) {
      console.error('An error occurred while fetching rule sets.');
      return [];
    }

    return response.data;
  }
}
